// Staff (admin CP) password policy. The server enforces the same rules (see
// investcore/src/pkg/security/password.go); this copy only gives early
// feedback in forms.

export const STAFF_PASSWORD_MIN_LENGTH = 12;
// bcrypt ignores everything past 72 bytes.
export const STAFF_PASSWORD_MAX_BYTES = 72;

const BANNED_WORDS = [
  'password',
  'passw0rd',
  'matkhau',
  '123456',
  'abcdef',
  'qwerty',
  'admin',
  'stag',
];

export const STAFF_PASSWORD_HINT =
  'Ít nhất 12 ký tự, gồm chữ in hoa, chữ thường, chữ số và ký tự đặc biệt; không chứa tên email hoặc từ dễ đoán (password, admin, stag, 123456...).';

// Returns the unmet rules (in Vietnamese); empty when the password is fine.
export function staffPasswordProblems(password: string, email = ''): string[] {
  const problems: string[] = [];

  if ([...password].length < STAFF_PASSWORD_MIN_LENGTH) {
    problems.push('ít nhất 12 ký tự');
  }
  if (new TextEncoder().encode(password).length > STAFF_PASSWORD_MAX_BYTES) {
    problems.push('tối đa 72 byte');
  }
  if (!/\p{Lu}/u.test(password)) problems.push('có chữ in hoa');
  if (!/\p{Ll}/u.test(password)) problems.push('có chữ thường');
  if (!/\p{Nd}/u.test(password)) problems.push('có chữ số');
  if (!/[^\p{L}\p{Nd}\s]/u.test(password)) problems.push('có ký tự đặc biệt');
  if (password.trim() !== password) {
    problems.push('không bắt đầu hoặc kết thúc bằng khoảng trắng');
  }

  const lower = password.toLowerCase();
  const emailName = email
    .trim()
    .toLowerCase()
    .split('@')[0];
  if (emailName.length >= 3 && lower.includes(emailName)) {
    problems.push('không chứa tên email');
  }
  if (BANNED_WORDS.some(word => lower.includes(word))) {
    problems.push('không chứa từ dễ đoán (password, admin, stag, 123456...)');
  }

  return problems;
}

// A message for the first form error, or '' when the password is fine.
export function staffPasswordError(password: string, email = ''): string {
  const problems = staffPasswordProblems(password, email);
  return problems.length
    ? `Mật khẩu chưa đủ mạnh, cần: ${problems.join(', ')}`
    : '';
}

// antd Form rule; getEmail is read at validation time.
export const staffPasswordRule = (
  getEmail: () => string | undefined = () => ''
) => () => ({
  validator(_: unknown, value?: string) {
    if (!value) return Promise.resolve(); // `required` reports empty values
    const error = staffPasswordError(value, getEmail() || '');
    return error ? Promise.reject(new Error(error)) : Promise.resolve();
  },
});
